
<template>
    <div>
        <mars-view class="container" @click.native="clickAll"><mars-view id="top-bar-box"><top-bar title="律师搜索" text-color="#242A33"></top-bar></mars-view><mars-view class="search-container"><mars-view class="search-bar-wrapper"><mars-view class="search-bar l-span c-font-normal"><mars-view class="search-bar-icon"></mars-view><mars-input class="search-bar-input" :value="inputQuery" placeholder-class="search-bar-placeholder" placeholder="请输入律师姓名" confirm-type="search" focus @input="searchInputFn" @confirm="searchTapFn(inputQuery)"></mars-input><c-icon v-if="inputQuery && !searchedState" class="search-bar-cancel" name="close-circle-solid" @click.native="searchCancelFn"></c-icon><mars-view class="search-bar-submit c-padding-h" @click.native="searchTapFn(inputQuery)">
                    {{ searchedState ? '取消' : '搜索' }}
                </mars-view></mars-view></mars-view><mars-view v-if="topLoading"><c-loading class="loading"></c-loading></mars-view><mars-view v-else><mars-view v-if="searchResult && searchResult.length !== 0" class="search-result-wrapper"><mars-view class="search-result-experts"><mars-view v-for="(expert, index) in searchResult" :key="index" class="search-result-expert"><new-lawyer :lawyer-info="expert"></new-lawyer></mars-view></mars-view><mars-view class="l-text-center c-font-normal c-color-gray c-gap-bottom-large">
                    没有更多了
                </mars-view><mars-view v-if="bottomLoading" class="l-span-center"><mars-image class="bottom-loading-icon" :lazy-load="true" src="https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=2916203555,3196138030&fm=179&app=35&f=GIF?w=300&h=150&s=69C03262DFE7BB510C50D41B0000E0C1"></mars-image></mars-view></mars-view><mars-view v-else-if="isUpdateLawyerList && searchResult && searchResult.length === 0" class="no-result"><mars-view class="no-result-icon l-icon l-icon-no-content"></mars-view><mars-text class="no-result-tip c-gap-top-large c-font-medium">
                    暂无相关律师
                </mars-text></mars-view></mars-view></mars-view></mars-view>
    </div>
</template>

<script>
import newLawyer from "../../components/home/new-lawyer.vue";
import Icon from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Icon/Icon.vue";
import Loading from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Loading/Loading.vue";
import { request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import Topbar from "../../components/common/topbar.vue";
export default {
  components: {
    'new-lawyer': newLawyer,
    'c-icon': Icon,
    'top-bar': Topbar,
    'c-loading': Loading
  },
  data() {
    return {
      inputQuery: '',
      searchedState: false,
      topLoading: false,
      bottomLoading: false,
      noMoreResult: false,
      topBar: {
        title: '律师搜索',
        color: '#000',
        bgColor: '#fff'
      },
      query: '',
      searchResult: [],
      menu: [],
      isUpdateLawyerList: false,
      dropdownLock: false
    };
  },
  methods: {
    // 搜索栏输入
    searchInputFn(e) {
      this.inputQuery = e.detail.value;
    },
    // 搜索栏清空
    searchCancelFn() {
      this.inputQuery = '';
    },
    // 状态初始化
    initState() {
      this.searchedState = false;
      this.topLoading = false;
      this.bottomLoading = false;
      this.noMoreResult = false;
      this.searchResult = [];
      this.query = '';
      this.inputQuery = '';
    },
    // 搜索or取消
    searchTapFn(query, filterNode) {
      if (this.searchedState) {
        // 取消搜索
        this.initState();
      } else {
        // 搜索
        this.inputQuery = query;

        // 过滤标签字符
        if (filterNode) {
          query = query.replace(/<[^>]*>/g, '');
        }
        this.searchedState = true; // 搜索态
        this.topLoading = true; // 加载态
        this.query = query;

        // 获取搜索结果
        this.updateExpertList().then(() => {
          this.topLoading = false;
        });
      }
    },
    updateExpertList() {
      // 异步请求律师
      return request({
        url: reqPathTo('lawyerlistbyname', {}, '', 'falv/lawyer'),
        data: {
          name: this.query
        }
      }).then(res => {
        try {
          let {
            lawyer_list = []
          } = res.data.data;
          lawyer_list = lawyer_list.map(item => {
            item.lawyer_service = [item.lawyer_service];
            return item;
          });
          this.isUpdateLawyerList = true;
          this.searchResult = [...lawyer_list];
        } catch (e) {}
      });
    },
    // 无限下拉异步请求律师
    getAsyncExperts() {
      if (this.dropdownLock) {
        return;
      }
      this.dropdownLock = true;
      setTimeout(() => {
        this.dropdownLock = false;
      }, 300);
      this.bottomLoading = true;
      this.updateExpertList().then(() => {
        this.bottomLoading = false;
      });
    },
    onReachBottom() {
      if (this.noMoreResult || this.bottomLoading) {
        return;
      }
      this.getAsyncExperts();
    }
  },
  created() {
    (function () {
      this.filterTop = 95;
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.search-container .search-bar-wrapper {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  padding-top: 0.05rem;
  padding-bottom: 0.1rem;
  background: #fff;
}
.search-container .search-bar-wrapper .search-bar {
  height: 38px;
  background: #f5f6f9;
  padding-left: 0.1rem;
  border-radius: 19px;
  display: flex;
  align-items: center;
  margin: 0 0.13rem;
}
.search-container .search-bar-wrapper .search-bar-icon {
  width: 16px;
  height: 16px;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/new-home/square/search-black.png') no-repeat;
  background-size: 100% 100%;
  margin-left: 1px;
  margin-right: 3px;
  vertical-align: text-top;
}
.search-container .search-bar-wrapper .search-bar-placeholder {
  color: #999;
  font-size: 14px;
}
.search-container .search-bar-wrapper .search-bar-input {
  width: 50%;
  font-size: 14px;
  background: #f5f6f9;
}
.search-container .search-bar-wrapper .search-bar-input:focus {
  outline: none;
}
.search-container .search-bar-wrapper .search-bar-input::-webkit-search-cancel-button {
  display: none;
}
.search-container .search-bar-wrapper .search-bar-cancel {
  color: #ccc;
  padding: 10px 0;
  vertical-align: text-top;
}
.search-container .search-bar-wrapper .search-bar-submit {
  position: relative;
  color: #3b6fff;
  font-size: 14px;
  font-weight: 700;
}
.search-container .loading {
  position: relative;
  top: 140px;
}
.search-container .no-result {
  text-align: center;
  padding-top: 78px;
}
.search-container .no-result-tip {
  color: #848691;
  font-size: 0.14rem;
}
.search-container .search-result-wrapper {
  padding: 40px 10px 0;
}
.search-container .search-result-wrapper .search-result-experts {
  margin: 22px 0;
  padding-bottom: 7px;
  background: #fff;
  border-radius: 12px;
}
.search-container .search-result-wrapper .bottom-loading-icon {
  width: 100px;
  height: 50px;
}

</style>
